import { Component, Vue } from "vue-property-decorator";
import { setDefaultLibs, openNewTab } from "@/public/utils/tool";
import appConfig from "@/public/globalConfig";

@Component
export default class addNew extends Vue {
    activeAIKey = "";
    aiPanelKey = "";

    get isAd() {
        return this.$store.state.isAd;
    }
    addNewPage(fileSource = "") {
        let ts: any = this;
        let maxAction = this.$store.state.appState;
        let typeTrack = "default";
        if (maxAction) {
            if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
            return;
        }

        if (this.aiPanelKey) {
            setDefaultLibs(this.aiPanelKey);
        }

        if (this.isPlugin) {
            location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=board`;
            return;
        }

        if (!this.$validateLogin()) return;

        let newTab: any;
        let newTabCallback;
        let cancelOpen;
        if (!this.openInTabs) {
            let task = openNewTab(`${window.location.origin}${appConfig["sourcePath"]}app.html`, this.$edMessage.destroy);
            newTabCallback = task.openTab;
            cancelOpen = task.cancelOpen;
            this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
        }

        let limitCallback = (type = "") => {
            newTab && newTab.close();
            cancelOpen && cancelOpen();
            this.$edMessage.destroy();
            if (type == "showLimitModal") {
                this.$bus.$on("limitModalContinue", () => {
                    this.$bus.$off("limitModalContinue");
                    this.addNewPage(fileSource);
                });
                this.$store.commit("setState", {
                    type: "showLimitFileModal",
                    data: true,
                });
            } else if (type == "showLimitCloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            } else if (type == "showLimitCloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else {
                this.$store.commit("toPublicStatus", {
                    type: "showUpgrade",
                    data: "fileNum",
                });
            }
        };

        let enterCanvasTrack = `&file_source=${fileSource ? fileSource : "emptyFile"}&template_type=noTemplate&diagram_type=${typeTrack}&fromNull=1`;
        let trackSuffix = this.isAd ? `&from=ad` : "";
        let aiSuffix = this.activeAIKey;
        (aiSuffix = aiSuffix ? `&aiStatus=${aiSuffix}` : ""), (trackSuffix += enterCanvasTrack);

        this.$openFile({
            params: {
                newFileName: this.$t("newFile"),
                libs: JSON.parse(localStorage.getItem("libs") || "[]"),
                platform: this.$store.state.publicStore.runPlatform,
            },
            fileType: "emptyFile",
            suffix: trackSuffix + aiSuffix,
            checkLimit: true,
            limitRange: this.$store.state.publicStore.runPlatform,
            limitCallback: limitCallback,
            vip: this.vip,
            isFullCouldSpace: this.isFullCouldSpace,
        }).then((obj) => {
            this.$gaTrack("openFileProcess_enterCanvas", `fileSource: emptyFile}`);
            this.sensors.track("generateCloudFile", {
                Catalogues: "openFileProcess",
                file_source: fileSource ? fileSource : "templateFile",
            });
            this.sensors.track("newFile", {
                Catalogues: "openFileProcess",
                new_file_type: "emptyFile",
            });
            if (this.openInTabs) {
                location.href = obj.url;
            } else {
                this.$edMessage.destroy();
                newTab = newTabCallback(obj.url);
            }
            this.$store.commit("setAppState", "create");
            let timer = setInterval(() => {
                try {
                    newTab.name;
                    newTab.name = obj.obj;
                    if (!newTab.name) {
                        this.$store.commit("setAppState", "");
                        clearInterval(timer);
                    }
                    if (!newTab.location.hash) {
                        this.$store.commit("setAppState", "");
                        clearInterval(timer);
                    }
                } finally {
                }
            }, 1000);

            // add open record
            let key = obj.obj;
            let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            if (!openTabs.includes(key)) {
                openTabs.push(key);
            }
            this.$store.commit("addWin", newTab);
            localStorage.setItem("openTabs", JSON.stringify(openTabs));
        });
    }
}
